import PublicSongsResult from './PublicSongsResult';

export default PublicSongsResult;
